"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GlRendererOptions = void 0;
const rc_js_util_1 = require("rc-js-util");
/**
 * @public
 * {@inheritDoc IGlRendererOptions}
 */
class GlRendererOptions {
    constructor(requiredExtensions, attributes, featureFlags) {
        this.onCreate = {
            featuresToEnable: featureFlags !== null && featureFlags !== void 0 ? featureFlags : ["CULL_FACE", "DEPTH_TEST", "SCISSOR_TEST"],
            requiredExtensionsToGet: requiredExtensions,
            contextAttributes: attributes,
        };
        this.onNewFrame = {
            bufferBitsToClear: ["COLOR_BUFFER_BIT", "DEPTH_BUFFER_BIT"],
            clearWithColor: rc_js_util_1.Vec4.f32.factory.createOne(0, 0, 0, 0),
        };
    }
}
exports.GlRendererOptions = GlRendererOptions;
//# sourceMappingURL=gl-renderer-options.js.map